import React, { useState, useMemo, useEffect } from 'react';
import { Drawer, Descriptions, Button, Modal, message, Form, Input } from 'antd';
import CheckStatus from '../check-status';
import './index.less';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import apis from '@/pages/material-manage/apis';
import query from '@/apis';

export default (props) => {
  const { data } = props;
  const _subTitle = data ? (
    <div className="check-name">
      <span className="source-name">申请人：{data.applyPin}</span>
      <span className="channel-name">申请时间：{data.created}</span>
    </div>
  ) : null;
  const _footer =
    data && data.checkStatus === 0 ? (
      <>
        <Button type="primary" danger onClick={() => setIsCheckrejectShow(true)}>
          驳回
        </Button>
        <Button type="primary" style={{ marginLeft: '24px' }} onClick={() => setIsCheckpassShow(true)}>
          通过
        </Button>
      </>
    ) : null;

  const { visible, onClose, refreshList, subTitle = _subTitle, footer = _footer } = props;
  const [form] = Form.useForm();
  const [isCheckrejectShow, setIsCheckrejectShow] = useState(false);
  const [isCheckpassShow, setIsCheckpassShow] = useState(false);
  const [category, setCategory] = useState({
    // 类目
    departments: '',
  });

  const conditions = useMemo(() => {
    return {
      checkId: [data.checkId],
      accountId: data.parentAccountId,
    };
  }, [data]);

  // 获取品类范围
  useEffect(() => {
    query.statisticTree({ type: 1 }).then((res) => {
      const { ret, data } = res;
      if (ret !== '0' || !data) return;
      setCategory({ departments: data });
    });
  }, []);

  // 遍历品类id，查询品类名称
  function mapCategoryName(ids, category) {
    if (!ids || !category) return '';
    const idArr = ids.split(',');
    const names = [];
    for (let i = 0; i < idArr.length; i++) {
      getCategoryName(idArr[i], category);
    }
    return names.join(',');

    function getCategoryName(id, category) {
      for (let j = 0; j < category.length; j++) {
        if (id === category[j].value) {
          names.push(category[j].name);
          return;
        }
        if (category[j].children) {
          getCategoryName(id, category[j].children);
        }
      }
    }
  }

  // 审核通过
  function checkPass() {
    apis
      .checkWriteServiceCheckPass(conditions)
      .then((res) => {
        if (res.ret === '0' && res.data) {
          const items = res.data.items;
          if (items && items[0] && items[0].success) {
            message.success('通过成功！');
            setIsCheckpassShow(false);
            onClose();
            refreshList();
          } else {
            message.error('通过失败！');
          }
        } else {
          message.error(res.msg);
        }
      })
      .catch((ex) => {
        message.error('接口请求错误，请稍后重试！');
      });
  }

  // 审核驳回
  function submitRejectInfo() {
    const value = form.getFieldsValue();
    const conditions = {
      checkId: [data.checkId],
      remark: value.remark,
    };
    apis
      .checkWriteServiceCheckReject(conditions)
      .then((res) => {
        if (res.ret === '0' && res.data) {
          const items = res.data.items;
          if (items && items[0] && items[0].success) {
            message.success('驳回成功！');
            setIsCheckrejectShow(false);
            onClose();
            refreshList();
          } else {
            message.error('驳回失败！');
          }
        } else {
          message.error(res.msg);
        }
      })
      .catch((ex) => {
        message.error('接口请求错误，请稍后重试！');
      });
  }

  // 取出数据中对应字段的value值
  function getCodeInfo(name) {
    const codeInfo = data.applyItemMicroVOList.find((item) => item.itemName === name);
    // if (codeInfo) {
    //   if (codeInfo.itemType === 18) { // 表示选择框，需要展示选择的内容
    //     return codeInfo.optionText
    //   } else {
    //     return codeInfo.value
    //   }
    // }
    return codeInfo || '';
  }

  // 下载pin包
  function downloadPin(url) {
    window.open(url);
  }

  return (
    !!data && (
      <Drawer
        visible={visible}
        onClose={onClose}
        width={600}
        className="check-drawer"
        title={
          <div className="check-drawer-title">
            <div className="check-id">
              <span className="id">资源申请编号：{data.id}</span>
              <CheckStatus checkStatus={data.checkStatus} />
            </div>
            {subTitle}
          </div>
        }
        footer={footer}
      >
        <Descriptions title="基本信息" column={1}>
          {/* {
          data.applyItemMicroVOList.map((item, index) => {
            return (
              <Descriptions.Item label={item.itemName} key={index}>
                {
                  item.itemType === 2 ? (
                    <image src={item.value} />
                  ) : item.value
                }
              </Descriptions.Item>
            )
          })
        } */}
          <Descriptions.Item label="频道名称">{getCodeInfo('频道名称').value}</Descriptions.Item>
          <Descriptions.Item label="频道描述">{getCodeInfo('频道描述').value}</Descriptions.Item>
          <Descriptions.Item label="主运营方">{getCodeInfo('主运营方').value}</Descriptions.Item>
          <Descriptions.Item label="对接人erp">{getCodeInfo('对接人erp').value}</Descriptions.Item>
          <Descriptions.Item label="频道类型">{getCodeInfo('频道类型').optionText}</Descriptions.Item>
          <Descriptions.Item label="品类范围">
            {mapCategoryName(getCodeInfo('品类范围').value, category.departments)}
          </Descriptions.Item>
          <Descriptions.Item label="频道实现方式">{getCodeInfo('频道实现方式').optionText}</Descriptions.Item>
          <Descriptions.Item label="频道URL">{getCodeInfo('频道URL').value}</Descriptions.Item>
          <Descriptions.Item label="频道兜底入口图1">
            <img width={100} src={getCodeInfo('频道兜底入口图1').value} />
          </Descriptions.Item>
          <Descriptions.Item label="频道兜底入口图2">
            <img width={100} src={getCodeInfo('频道兜底入口图2').value} />
          </Descriptions.Item>
          <Descriptions.Item label="10.0频道头像">
            <img width={100} src={getCodeInfo('10.0频道头像').value} />
          </Descriptions.Item>
          <Descriptions.Item label="频道运营语">{getCodeInfo('频道运营语').value}</Descriptions.Item>
        </Descriptions>
        <Descriptions title="投放策略" column={1}>
          <Descriptions.Item label="投放人群">
            <div className="crowd-type">
              <div>{getCodeInfo('投放人群').optionText}</div>
              {getCodeInfo('投放人群').value === '1' ? (
                <div className="pin-load">
                  {/* <FileTextOutlined /> */}
                  <a onClick={() => downloadPin(getCodeInfo('圈选值').value)}>{getCodeInfo('圈选值').value}</a>
                </div>
              ) : (
                <div className="pin-load">经海路标签ID：{getCodeInfo('圈选值').value}</div>
              )}
            </div>
          </Descriptions.Item>
        </Descriptions>
        <Modal
          className="model-check-pass"
          visible={isCheckpassShow}
          onCancel={() => setIsCheckpassShow(false)}
          onOk={checkPass}
          closable={false}
        >
          <ExclamationCircleOutlined />
          <div>
            <div className="pass-title">提示</div>
            <div className="pass-content">确认要通过该条资源申请吗？</div>
          </div>
        </Modal>
        <Modal
          className="model-check-reject"
          destroyOnClose
          title={
            <div className="reject-title">
              <ExclamationCircleOutlined />
              <span>确认要驳回该条资源申请吗？</span>
            </div>
          }
          visible={isCheckrejectShow}
          onCancel={() => setIsCheckrejectShow(false)}
          footer={null}
        >
          <Form form={form} validateTrigger="onSubmit" preserve={false} onFinish={submitRejectInfo}>
            <Form.Item
              label="驳回原因"
              name="remark"
              rules={[
                {
                  required: true,
                  message: '请输入驳回原因',
                },
                {
                  max: 200,
                  message: '请输入不超过200字的驳回原因',
                },
              ]}
            >
              <Input.TextArea placeholder="请输入不超过200字的驳回原因" rows={4} />
            </Form.Item>
            <Form.Item className="reject-btns">
              <Button style={{ marginRight: '15px' }} onClick={() => setIsCheckrejectShow(false)}>
                取消
              </Button>
              <Button htmlType="submit" type="primary">
                确定
              </Button>
            </Form.Item>
          </Form>
        </Modal>
      </Drawer>
    )
  );
};
